import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Observable } from "rxjs";


import { LocalStorage } from './localstorage.service';

@Injectable()
export class AuthenticationService {
    
    constructor(
        private _localStorage: LocalStorage) {

        this._token = this._localStorage.getItem('authToken') as string;
        this._username = this._localStorage.getItem('username') as string;
        this._password = this._localStorage.getItem('password') as string;
        this._role = this._localStorage.getItem('role') as string;
        this._isAuthenticated = (this.token != null && this.token.length > 0);
        this._fromDateSearch = this._localStorage.getItem('fromDateSearch') as string;
        this._toDateSearch = this._localStorage.getItem('toDateSearch') as string;
        this._criticalLevelSearch = this._localStorage.getItem('criticalLevelSearch') as string;
        this._queueCategorySearch = this._localStorage.getItem('queueCategorySearch') as string;
        this._currentState = this._localStorage.getItem('currentState') as string;    
    }

    // Token property
    private _token: string = '';
    get token(): string {
        return this._token;
    }
    set token(val: string) {
        this._token = val;
        if (this._token && this._token.length > 0) {
            this._localStorage.setItem('authToken', this._token);
        } else {
            this._localStorage.removeItem('authToken');
        }

    }

 
    
    // IsAuthenticated property
    private _isAuthenticated: boolean = false;
    get isAuthenticated(): boolean {
        return this._isAuthenticated;
    }
    set isAuthenticated(val: boolean) {
        this._isAuthenticated = val;
    }

    // Username property
    private _username = "";
    get username(): string {
        return this._username;
    }
    set username(val: string) {
        this._username = val;
        if (this._username && this._username.length > 0) {
            this._localStorage.setItem('username', this._username);
        } else {
            this._localStorage.removeItem('username');
        }
    }

    private _password = "";
    get password(): string {
        return this._password;
    }
    set password(val: string) {
        this._password = val;
        if (this._password && this._password.length > 0) {
            this._localStorage.setItem('password', this._password);
        } else {
            this._localStorage.removeItem('password');
        }
    }

    private _currentState = "";
    get currentState(): string {
        return this._currentState;
    }
    set currentState(val: string) {
        this._currentState = val;
        if (this._currentState && this._currentState.length > 0) {
            this._localStorage.setItem('currentState', this._currentState);
        } else {
            this._localStorage.removeItem('currentState');
        }

    }
    // Role property
    private _role = "";
    get role(): string {
        return this._role;
    }
    set role(val: string) {
        this._role = val;
        if (this._role && this._role.length > 0) {
            this._localStorage.setItem('role', this._role);
        } else {
            this._localStorage.removeItem('role');
        }
    }

    private _fromDateSearch: string = '';
    private _toDateSearch: string = '';
    private _criticalLevelSearch: string = '';
    private _queueCategorySearch: string = '';

    get fromDateSearch(): string {
        return this._fromDateSearch;
    }
    set fromDateSearch(val: string) {
        this._fromDateSearch = val;
        if (this._fromDateSearch && this._fromDateSearch.length > 0) {
            this._localStorage.setItem('fromDateSearch', this._fromDateSearch);
        } else {
            this._localStorage.removeItem('fromDateSearch');
        }
    }

    get toDateSearch(): string {
        return this._toDateSearch;
    }
    set toDateSearch(val: string) {
        this._toDateSearch = val;
        if (this._toDateSearch && this._toDateSearch.length > 0) {
            this._localStorage.setItem('toDateSearch', this._toDateSearch);
        } else {
            this._localStorage.removeItem('toDateSearch');
        }
    }

    get criticalLevelSearch(): string {
        return this._criticalLevelSearch;
    }
    set criticalLevelSearch(val: string) {
        this._criticalLevelSearch = val;
        if (this._criticalLevelSearch && this._criticalLevelSearch.length > 0) {
            this._localStorage.setItem('criticalLevelSearch', this._criticalLevelSearch);
        } else {
            this._localStorage.removeItem('criticalLevelSearch');
        }
    }

    get queueCategorySearch(): string {
        return this._queueCategorySearch;
    }
    set queueCategorySearch(val: string) {
        this._queueCategorySearch = val;
        if (this._queueCategorySearch && this._queueCategorySearch.length > 0) {
            this._localStorage.setItem('queueCategorySearch', this._queueCategorySearch);
        } else {
            this._localStorage.removeItem('queueCategorySearch');
        }
    }

    getAuthorizationHeader(): string {
        return this.isAuthenticated ? `Bearer ${this.token}` : '';
    }

    set(token: string, user: string, role: string, currentState: string, password: string) {
        this.token = token || '';
        this.username = user || '';
        this.role = role || '';
        this.password = password || '';
        this.isAuthenticated = (this.token != null && this.token.length && this.role.length > 0);
        this.currentState = currentState || '';
    }

    setSearch(fromDateSearch: string, toDateSearch: string, criticalLevelSearch: string, queueCategorySearch: string){
        this.fromDateSearch = fromDateSearch || '';
        this.toDateSearch = toDateSearch || '';
        this.criticalLevelSearch = criticalLevelSearch || '';
        this.queueCategorySearch = queueCategorySearch || '';
    }

    clear(): void {
        this.token = '';
        this.username = '';
        this.isAuthenticated = false;
    }
}
